
import { defineComponent, Ref, ref, onBeforeUnmount, computed } from 'vue'
import AppHeader from '@/components/Header.vue'
import { GetPurchaseDetail } from '@/apis/standby'
import getRoute from '@/compositions/route'
import { Toast } from 'vant'
import { PurchaseDetail } from '@/types/standby'
import { ComponentInstance } from 'vant/lib/utils'

export default defineComponent({
  name: 'Standby-Orderdetail',
  components: {
    AppHeader,
  },
  setup() {
    const items: Ref<PurchaseDetail[]> = ref([])
    let _ts: number = Date.now()
    const { params, query } = getRoute()
    let toast: ComponentInstance = null
    const getItems = async (): Promise<void> => {
      const ts: number = _ts
      toast = Toast({
        type: 'loading',
        message: '加载中...',
        forbidClick: true,
        duration: 0,
      })
      try {
        let list: PurchaseDetail[] = await GetPurchaseDetail({
          pay_order: (params.value?.sn as string) || '',
        })
        if (ts !== _ts) return
        toast.clear()
        items.value = list
      } catch (err: unknown) {
        if (ts !== _ts) return
        toast.clear()
        const message: string = (err as { message: string }).message
        Toast(message)
        console.error(message)
      }
    }
    getItems()
    const payIconClass = computed(() => {
      let cla = 'success-icon'
      switch(query.value.type as string) {
        case '2':
          cla = 'doing-icon'
          break
        case '3':
          cla = 'fail-icon'
          break
      }
      return cla
    })
    const payStatusTxt= computed(() => {
      let str = '已支付'
      switch(query.value.type as string) {
        case '2':
          str = '支付中'
          break
        case '3':
          str = '支付失败'
          break
      }
      return str
    })
    const allMoney = computed(() => {
      return items.value.reduce((total, cur) => {
        return total + Number(cur.price) * cur.day
      }, 0)
    })
    const orderNo = computed(() => {
      return items.value[0]?.sn || ''
    })
    const createdTime = computed(() => {
      return items.value[0]?.created_at.slice(0, 16) || ''
    })
    onBeforeUnmount(() => {
      if (toast) {
        toast.clear()
        toast = null
      }
      _ts = 0
    })
    return {
      items,
      allMoney,
      orderNo,
      createdTime,
      payIconClass,
      payStatusTxt,
    }
  },
})
